// extracted by mini-css-extract-plugin
export default {"mdBreak":"1024px","notificationBar":"_B4GJjakCQ8BLq3gmUTw"};